//Adapted from https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript

const createCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

const readCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const updateCookie = function (name, value, days) {
    createCookie(name, value, days);
}

const eraseCookie = function (name) {
    createCookie(name, "", -1);
}

module.exports = {
    create: createCookie,
    read: readCookie,
    update: updateCookie,
    erase: eraseCookie
};


// WEBPACK FOOTER //
// ./shared/scripts/cookieManagement.js